import {SearchLinksListDefaultBox} from "./search-links-list.default.box";

export const SearchLinksListBox = SearchLinksListDefaultBox;